const Neptune = {
    name: "aliens_gate",
    socials: {
        Instagram: "https://www.instagram.com/aliens_gate",
        Bluesky: "https://bsky.app/profile/aliens.bsky.social"
    }
}

const Tao = {
    name: "Khaiiiju",
    socials: {
        Instagram: "https://www.instagram.com/khaiiiju/"
    }
}

const Polyana = {
    name: "Polyana",
    socials: {
        Instagram: "https://www.instagram.com/bunnym0uth_/",
        Bluesky: "https://bsky.app/profile/bunnymouth.bsky.social"
    }
}

export const dat = [
    {
        path: "dstm",
        title: "DONT STOP THE MUSIC",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/dontstopthemusic.png",
        details: {
            rd: "February 2, 2026",
            desc: "DONT STOP THE MUSIC is the second release in the keres series of releases by HYPERPUP. The song is (similarly to Mind Fuck) about experiencing artistic burnout, but how that makes artists more human and intrinsically better than machines.",
            artist: Polyana,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/dont-stop-the-music?si=e672aebf04894408b072ce2b23aa7056&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://hyperpup.bandcamp.com/album/dont-stop-the-music",
                "https://open.spotify.com/album/2yrfMoScMrPwMzfeUNVMvN?si=ZCpfTIr_RCGByk_na01fUw",
                "https://music.apple.com/us/album/dont-stop-the-music-single/1876171466"
            ]
        }
    },
    {
        path: "llgm",
        title: "LIVELEAK GOREMUTT",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/liveleak.jpg",
        details: {
            rd: "January 22, 2026",
            desc: "LIVELEAK GOREMUTT is the first release in the keres series by HYPERPUP. The song details intense themes about death, trauma, and depression.",
            artist: Tao,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/liveleak-goremutt-feat-niomi?si=cdcd9d0aea76460d846868f616025885&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://hyperpup.bandcamp.com/album/liveleak-goremutt-feat-niomi",
                "https://open.spotify.com/album/2t9jSRYiFfgs4UkiGSivzB?si=X58e91-uRCqib8_XNDGf3g",
                "https://music.apple.com/us/album/liveleak-goremutt-feat-niomi/1868035585?i=1868035586"
            ]
        }
    },
    {
        path: "lbstr",
        title: "LEWDBUSTER",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/lewdbuster.jpg",
        details: {
            rd: "August 25, 2025",
            desc: "Just a standard cover of Rude Buster by Toby Fox.",
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/lewdbuster?si=a702e3b4d05f45d9830e671ca3ae4850&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://open.spotify.com/track/1yeH6VstuXn1iU1ZBS3u69?si=d05552c0f4234846",
                "https://music.apple.com/us/album/lewdbuster-single/1834183048"
            ]
        }
    },
    {
        path: "mfk",
        title: "MIND FUCK",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/mindfuck.png",
        details: {
            rd: "April 24, 2025",
            desc: "MIND FUCK is an experimental vocaloid song scrapped off of the HYPERPUP unreleased album ALTERGIRLS. The song is about experiencing burnout.",
            artist: Neptune,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/mind-fuck?si=638c238a2bcb442fb4da9e297263562b&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://open.spotify.com/track/168KYZU59WwHP59Lrou3YJ?si=c9c9866981e84ae7",
                "https://music.apple.com/us/album/mind-f-k-feat-hatsune-miku-single/1809446967"
            ]
        }
    },
    {
        path: "ppb",
        title: "PIEN PIEN BEAM (ft. Hatsune Miku)",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/pien.png",
        details: {
            rd: "April 21, 2025",
            desc: "PIEN PIEN BEAM is a song about Jirai Girls and parasociality. The lyrics are dark, and the themes are even darker.",
            artist: Neptune,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/pien-pien-beam-feat-hatsune-miku?si=0c1db8760b70453784bae41898a0c08a&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://hyperpup.bandcamp.com/track/pien-pien-beam",
                "https://open.spotify.com/track/2s6xpeCiGCxnbZ0yaGBJHY?si=b2aa08d5afb740f3",
                "https://music.apple.com/us/album/pien-pien-beam-feat-hatsune-miku-single/1808731546"
            ]
        }
    },
    {
        path: "yiff",
        title: "WHEN I GET HORNY I YIFF LIKE THIS",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/yiff.png",
        details: {
            rd: "April 21, 2025",
            desc: "WHEN I GET HORNY I YIFF LIKE THIS is an EP by HYPERPUP. The EP has no intrinsic meaning behind it, and it is just some rave IDs she spins live sometimes.",
            artist: Neptune,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/sets/when-i-get-horny-i-yiff-like-this?si=262fd9a9e0d94c768baa7939671e4b78&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://hyperpup.bandcamp.com/album/when-i-get-horny-i-yiff-like-this",
                "https://open.spotify.com/album/4OPtmsTWtEYf8OHCXXj1sT?si=YMRZnT0rRRSyW3jxup3sdw",
                "https://music.apple.com/us/album/when-i-get-horny-i-yiff-like-this-%E0%B9%91-%E1%B4%97-%E0%B9%91-single/1808964055"
            ]
        }
    },
    {
        path: "chsr",
        title: "TAIL CHASER",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/tail.png",
        details: {
            rd: "April 21, 2025",
            desc: "TAIL CHASER is an EP by HYPERPUP. The EP has no intrinsic meaning behind it, and it is just some rave IDs she spins live sometimes.",
            artist: Neptune,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/sets/tail-chaser?si=00624c78311f4a44ab056f7454d26186&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://hyperpup.bandcamp.com/album/tail-chaser",
                "https://open.spotify.com/album/6erKqjwGa5YErOkdvcunrb?si=tgYY0798Ta6iUT6acAMlvQ",
                "https://music.apple.com/us/album/tail-chaser-ep/1808963640"
            ]
        }
    },
    {
        path: "bugz",
        title: "BUGZINYRSKIN",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/bugz.png",
        details: {
            rd: "April 21, 2025",
            desc: "BUGZINYRSKIN is a single by HYPERPUP. The title is a reference to BUGCORE.",
            artist: Neptune,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/bugzinyrskin?si=3f57f27cef5341af8296eda6ccfa5d6c&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://hyperpup.bandcamp.com/track/bugzinyrskin",
                "https://open.spotify.com/track/3Wj2LfbwNGlFuo0L8vKeN1?si=6c3d216b46564ab2",
                "https://music.apple.com/us/album/bugsinyrskin-single/1808962464"
            ]
        }
    },
    {
        path: "mine",
        title: "You're Mine (feat. awerewa & Hatsune Miku)",
        media: "https://raw.githubusercontent.com/h3llo-wor1d/HYPERPUP_COVERS/refs/heads/main/mine.png",
        details: {
            rd: "April 21, 2025",
            desc: "You're Mine is an experimental vocaloid drum and bass song about love. The lyrics were written and transcribed by HYPERPUP, and sung in Vocaloid software as Hatsune Miku.",
            artist: Neptune,
            streaming: [
                "https://soundcloud.com/h3llo_wor1d/youre-mine-feat-hatsune-miku-awerewa?si=bf0e0ada05dc4a7f956e14acf99b7c73&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
                "https://hyperpup.bandcamp.com/track/youre-mine",
                "https://open.spotify.com/album/7basM6Xry33uO7cDQM22np?si=B-FJFucDSP2mW2lq5vVG5A",
                "https://music.apple.com/us/album/youre-mine-feat-awerewa-hatsune-miku/1808962572?i=1808962647"
            ]
        }
    }
]